<template>
  <div class="cities-list">
    <Toolbar title-tag="h1" class="mb-3">
      <template #title>
        {{ title }}
      </template>
    </Toolbar>
    <div class="cities-list__cities">
      <div class="row cities-list__row">
        <div v-for="(city, index) in cities" :key="index" class="col-lg-6">
          <CityButton :to="getLink(city)">{{
            city ? city.name : ""
          }}</CityButton>
        </div>
      </div>
    </div>
    <NationalFinalBtn v-if="finalLink" :to="finalLink">
      Национальный финал
    </NationalFinalBtn>
  </div>
</template>

<script>
import NationalFinalBtn from "./NationalFinalBtn";
import CityButton from "@/components/city/CityButton";
import { Toolbar } from "@/components/ui/toolbar/";
import { mapState, mapActions } from "vuex";

export default {
  name: "TeamsCategoriesPage",

  components: {
    NationalFinalBtn,
    CityButton,
    Toolbar
  },

  props: {
    title: String,
    finalLink: [String, Object],
    getLink: {
      type: Function,
      required: true
    }
  },

  computed: {
    ...mapState("dictionaries", {
      cities: ({ dictionaries }) => dictionaries.cities || new Array(3)
    })
  },

  created() {
    this.getDictionary({ name: "cities", force: true });
  },

  methods: {
    ...mapActions("dictionaries", ["getDictionary"])
  }
};
</script>

<style lang="scss">
.cities-list {
  &__cities {
    padding: 20px 0;
  }
  &__row {
    @include customGutter(20px);
  }

  @include breakpoint("lg-and-down") {
    &__row {
      @include customGutter(20px, 30px);
    }
  }

  @include breakpoint("xs-only") {
    &__row {
      // @include customGutter(10px);
    }
  }

  @media (max-width: 400px) {
    &__cities {
      margin-top: -20px;
    }
    &__row {
      @include customGutter(5px);
    }
  }
}
</style>
